// extracted by mini-css-extract-plugin
module.exports =  {"card":"x0glYGQoB5v8zV7j3Hsu","fBPreview":"OeMeIhZT_NrKDBfiPuKi"};